@if (iosDownloadMenu) {
  <app-ios-download-context
    [asset]="asset"
    [version]="version"
    [accessLevel]="accessLevel"
    [gallery]="gallery"
    [previewWidth]="previewWidth"
    (download)="download($event)"
  >
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </app-ios-download-context>
} @else if (!onlyOneSize) {
  <app-context-menu
    [options]="{ width: '240px', noSpacing: true }"
    #menu
    [position]="'right'"
    contextHoverIdentifier="asset-{{ asset.id }}"
  >
    <div contextButton [appTooltip]="'download-button' | translate">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
    <div contextContent>
      @if (menu.isOpen) {
        <app-download-size-selection
          [accessLevel]="accessLevel"
          [asset]="asset"
          [gallery]="gallery"
          (onSelect)="download($event); menu.close()"
        >
        </app-download-size-selection>
      }
    </div>
  </app-context-menu>
} @else {
  <div (click)="download(singleDownloadOption)">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </div>
}
<ng-template #template>
  <ng-content></ng-content>
</ng-template>
